import { TradeTabsType } from 'common/types';

export const subroute = '/platform';

export const clientAreaUrl = '/client-area';

export const routes = {
  getWebsite: () => window.location.origin,
  getBaseRoot: () => `${window.location.origin}${subroute}/`,
  getRoot: () => `${subroute}/`,
  getHome: () => `${subroute}/home`,
  getAboutUsPage: () => '/about-us',
  getAssetPage: () => `${subroute}/asset/:symbol/:direction?`,
  getAssetsPage: () => `${subroute}/assets`,
  getAssetSearchPage: () => `${subroute}/search`,
  getChangePasswordPage: () => `${subroute}/change-password`,
  getClientAreaPage: (page = ':page') => `${subroute}/client-area/${page}`,
  getContactUsPage: () => '/support',
  getCryptoPayPage: () => `${subroute}/crypto-pay`,
  getDepositPage: () => `${subroute}/deposit/:currency?/:amount?`,
  getDerivativesPage: () => `${subroute}/futures`,
  getDerivativesAssetPage: () => `${subroute}/futures/:symbol/:direction?`,
  getDerivativesEditPosition: () => `${subroute}/futures/:symbol?/position/:id`,
  getDerivativesEditPositionFromGrid: () => `${subroute}/futures/position/:id`,
  getExchangeFormPage: () => `${subroute}/exchange/:symbol?`,
  getBuyCryptoFormPage: () => `${subroute}/buy-crypto/:symbol?/:amount?`,
  getExchangeChooseCurrencyPage: () => `${subroute}/exchange/:symbol/choose`,
  getExchangeHistory: () => `${subroute}/exchange-history`,
  getHelpPage: () => `${subroute}/help`,
  getLogin: () => `${subroute}/login`,
  getLoginPage: () => `${clientAreaUrl}/login`,
  getLoyaltyPage: () => `${subroute}/loyalty-program`,
  getMarginPage: () => `${subroute}/margin`,
  getMenuPage: () => `${subroute}/menu`,
  getNotificationsPage: () => `${subroute}/notifications`,
  getOrdersPage: () => `${subroute}/orders`,
  getEditLimitOrderPage: () => `${subroute}/orders/edit/:id/:action?/:price?`,
  getReceivePage: () => `${subroute}/receive/:currency?/:amount?`,
  getRegisterPage: () => `${clientAreaUrl}/register`,
  getReferalPage: () => `${subroute}/referral`,
  getRewardsPage: () => `${subroute}/rewards`,
  getSecurityPage: () => `${subroute}/security`,
  getSendPage: () => `${subroute}/send/:currency?/:amount?`,
  getSettingsPage: () => `${subroute}/settings`,
  getTiersPage: () => `${clientAreaUrl}/loyalty-program?iframe=true`,
  getStatementPage: () => `${subroute}/statement`,
  getTradePage: (module: TradeTabsType = 'spot') => `${subroute}/${module}`,
  getTokenPresalePage: () => `${subroute}/pre-sale`,
  getPaymentCardPage: () => `${subroute}/payment-card`,
  getSpotPage: () => `${subroute}/spot`,
  getSpotPageLegacy: () => `${subroute}/trade`,
  getSpotAssetPage: () => `${subroute}/spot/:symbol/:direction?`,
  getCoinPage: () => `${subroute}/coin/:symbol`,
  getTransactionsPage: () => `${subroute}/wallet/transactions`,
  getVerificationLevelPage: () => `${subroute}/verification-level`,
  getWalletPage: () => `${subroute}/wallet`,
  getWireTransferPage: () => `${subroute}/wire-transfer/:currency?/:amount?`,
  getWithdrawalPage: () => `${subroute}/withdrawal/:currency?/:amount?`,
  getWithdrawalAddressPage: () => `${subroute}/withdrawal-address`,
  getTransferPage: () => `${subroute}/transfer/:fromType?/:toType?/:currency?`,
  getTransferChooseCurrencyPage: () => `${subroute}/transfer-choose/:currency/:fromType?/:toType?`,
  getEarnListPage: () => `${subroute}/earn/:mode?/:id?`,
  getEarnDetailsPage: (coin = ':coin') => `${subroute}/earn/${coin}`,
  getCreateEarnPage: (symbol = ':symbol?') => `${subroute}/earn/create/${symbol}`,
  getStocksPage: () => `${subroute}/stocks`,
  getStocksDashboardPage: () => `${subroute}/stocks/:symbol/:direction?`,
};
